export const CHART_TOOLBAR_ALL_DEALERS = '__all__' as const;

export type ChartToolbarDealerSelection = typeof CHART_TOOLBAR_ALL_DEALERS | string;
